"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _constants = require("./constants");

var _ImportDetails = _interopRequireDefault(require("./ImportDetails"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _actions2 = require("settings-ui-sdk/ShopifyConnection/actions");

var _handleActions;

var initialState = new _immutable.Map({
  status: _RequestStatusTypes.default.UNINITIALIZED,
  importDetails: new _ImportDetails.default(),
  error: null,
  skipToDashboardPage: true
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchEcommerceImportStatusActionTypes.PENDING, function (state) {
  return state.set('status', _RequestStatusTypes.default.PENDING);
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchEcommerceImportStatusActionTypes.SUCCESS, function (state, action) {
  if (action.payload.data !== _constants.ImportStatus.HAS_IMPORT || state.get('status').succeeded // prevents dependent loading containers from re-rendering when polling for import status
  ) {
      return state.set('status', _RequestStatusTypes.default.SUCCEEDED);
    }

  return state.set('skipToDashboardPage', false);
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchEcommerceImportDetailsActionTypes.SUCCESS, function (state, action) {
  return new _immutable.Map({
    status: _RequestStatusTypes.default.SUCCEEDED,
    importDetails: _ImportDetails.default.from(action.payload.data),
    skipToDashboardPage: state.get('skipToDashboardPage') && action.payload.data.stage === _constants.ImportStages.COMPLETE
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchEcommerceImportDetailsActionTypes.FAILURE, function (state, action) {
  if (action.payload.error) {
    return state.merge({
      status: _RequestStatusTypes.default.FAILED,
      error: action.payload.error
    });
  }

  return state.set('status', _RequestStatusTypes.default.FAILED);
}), (0, _defineProperty2.default)(_handleActions, _actions2.ShopifyConnectionActionTypes.FINISH_SHOPIFY_CONNECTION, function (state) {
  return state.set('skipToDashboardPage', false);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;